/*
  Solution 25 - Filter configuration
  ==================================

  Single-select filters: choosing a value replaces the previously chosen one,
  instead of adding to it. They are also shown as round, single-choice buttons
  automatically - no styling changes are needed.

  Colour and Material are always single-select. They are handled in the theme's
  JavaScript and do not need to be listed here.

  To make another filter single-select, add its Shopify filter parameter name to
  the list below - one per line, in quotes, ending with a comma:

      window.S25_CONFIG.singleSelectFilterParams = [
        'filter.v.m.custom.muster',
      ];

  Please only add or remove lines between the [ and ] brackets, and leave the
  rest of this file unchanged.
*/

window.S25_CONFIG = window.S25_CONFIG || {};

window.S25_CONFIG.singleSelectFilterParams = [
  // Add additional single-select filter parameter names here.
];
